window.dataLayer = window.dataLayer || [];

function whatsappClick() {
  const buttonWhats = document.querySelector("#WhatsappButton");

  if (buttonWhats) {
    buttonWhats.addEventListener("click", () => {
      window.dataLayer.push({
        event: "whatsapp_click",
        buttonId: "WhatsappButton",
      });
    });
  }
}

function whatsappFormOpened() {
  const modal = document.getElementById("WhatsappModal");

  if (!modal) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "open" && modal.hasAttribute("open")) {
        window.dataLayer.push({
          event: "whatsapp_form_opened",
          modalId: "WhatsappModal",
        });
      }
    });
  });

  observer.observe(modal, { attributes: true });
}

function whatsappFormSubmission() {
  const TICK = 300; // tempo em ms entre cada checagem

    const timer = setInterval(() => {
      const appEmbed = document.querySelector(".whatsapp-modal form-embed#app-embed");
      if (!appEmbed) return; 

      if (!appEmbed.shadowRoot) return; 

      const form = appEmbed.shadowRoot.querySelector('form[data-testid="form"]');
      if (!form) return; 


      if (form.dataset.bound === "1") {
        clearInterval(timer);
        return;
      }

      console.log("form", form);

      form.dataset.bound = "1";

      form.addEventListener("submit", () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "whatsapp_form_submission",
          formId: "app-embed",
        });
      });

      clearInterval(timer);
    }, TICK);
}

function pageView () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "page_view",
        page: {
            url: window.location.href,
            title: document.title
        }
    });
}

function siteSearch () {
    const searchForm = document.querySelector("form.search-modal__form");
    if (!searchForm) return;

    searchForm.addEventListener("submit", (e) => {
      const queryInput = searchForm.querySelector("input[name='q']");
      const searchQuery = queryInput ? queryInput.value : "";

      if (!searchQuery) return;


      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "site_search",
        search_term: searchQuery
      });

    });

}

function scroll90 () {
    let scrolled90 = false;

    window.addEventListener("scroll", () => {
      if (scrolled90) return;

      const scrollTop = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (scrollPercent >= 90) {
        scrolled90 = true; 
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "scroll_90",
          scrollPercent: 90
        });
      }
    });
}

window.addEventListener(
  "load",
  () => {
    whatsappClick();
    whatsappFormOpened();
    whatsappFormSubmission()
    pageView()
    siteSearch()
    scroll90()
  },
  false
);
